import { useState } from 'react';
import { RxHamburgerMenu } from 'react-icons/rx';
import nav from '../../css/Navbar.module.css';

import { IoMdSettings } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';
import img from '../../assest/dummy user.jpg';
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../Modals/Modals';
import SidebarOffcanvas from '../Sidebar/SidebarOffcanvas';

const Navbar = ({ admindata, toggleSidebar }) => {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const handleLogOut = async () => {
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('adminData');
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
    navigate('/');
  };

  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleLogOut}
        text="Logout"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Logged out"
      />
      <SidebarOffcanvas show={showSidebar} handleClose={() => setShowSidebar(false)} />

      <div className={nav.navbarcontainer}>
        <div className={nav.navbarsubcontainer}>
          <div className={nav.navsearchbarcotainer}>
            {/* <div className={nav.searchbarnav}>
                            <IoSearchSharp color='#8A8A8A' size={20} />
                            <input type="seach" placeholder='Search' />
                        </div> */}
            <RxHamburgerMenu size={25} color="#F05423" onClick={() => setShowSidebar(true)} />
            <h1>Admin Panel</h1>
          </div>

          <div className={nav.secondpartnav}>
            <div
              className={nav.notificationicon}
              onClick={() => navigate('/setting/commission/user')}
            >
              <IoMdSettings color="#282828" size={25} />
              {/* <div className={nav.notificationicon1}>
                                <FaCircle color='#2D88D4' size={13} />
                            </div> */}
            </div>
            <div className={nav.logoutnav} onClick={() => setShowDeleteModal(true)}>
              <p>Log out</p>
            </div>
            <div className={nav.profilepic} onClick={() => navigate('/adminprofile')}>
              <img src={admindata?.data?.image || img} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
